import { LeftProps } from './Types'
import Styles from './MobileTopBarContainer.module.scss'

export const Left = ({ children, ...props }: LeftProps) => {
  return (
    <div className={Styles.left} data-theme={props['data-theme']}>
      {children}
    </div>
  )
}
